import { forwardRef } from "react";
import type { ComponentPropsWithRef } from "react";

export interface LineBlockProps extends ComponentPropsWithRef<"div"> {
  borderStyle?: "solid" | "dashed" | "dotted";
  borderWidth?: number;
  color?: string;
  paddingX?: number;
  paddingY?: number;
  width?: number | string;
}

/* TODO: We could use app/javascript/react/components/shared/BuilderUI/utils/styleProcessors/processStyleValue.ts
to process the style values based on if it's passed as string or number */
const getStyleValue = (value: number | string) => {
  if (typeof value === "number") {
    return `${value}px`;
  }
  return value;
};

export const HorizontalLine = forwardRef<HTMLDivElement, LineBlockProps>(
  (
    {
      color = "#000",
      borderWidth = 1,
      paddingX = 16,
      paddingY = 16,
      borderStyle = "solid",
      width = "100%",
      ...rest
    },
    ref,
  ) => (
    <div ref={ref} {...rest}>
      <div
        className="wb-relative wb-flex wb-items-center wb-justify-center"
        style={{
          paddingLeft: getStyleValue(paddingX),
          paddingRight: getStyleValue(paddingX),
          paddingTop: getStyleValue(paddingY),
          paddingBottom: getStyleValue(paddingY),
        }}
      >
        <div
          className="wb-relative wb-flex wb-w-full"
          data-testid="builder-horizontal-line"
          style={{
            borderColor: color,
            borderTopWidth: getStyleValue(borderWidth),
            borderStyle,
            width: getStyleValue(width),
          }}
        />
      </div>
    </div>
  ),
);

HorizontalLine.displayName = "Line";
